import {
  ENQUEUE_PUBLISH_JOB,
  REMOVE_PUBLISH_JOB,
  UPDATE_PUBLISH_JOB_PROGRESS,
  MARK_BANNER_LIST_STALE,
  CLEAR_BANNER_LIST_STALE,
  MARK_TEMPLATE_LIST_STALE,
  CLEAR_TEMPLATE_LIST_STALE,
  MARK_PAGES_LIST_STALE,
  CLEAR_PAGES_LIST_STALE,
  MARK_CATEGORIES_LIST_STALE,
  CLEAR_CATEGORIES_LIST_STALE,
  MARK_WIDGETS_LIST_STALE,
  CLEAR_WIDGETS_LIST_STALE,
  MARK_SEO_LIST_STALE,
  CLEAR_SEO_LIST_STALE,
  MARK_INFORMATION_POLICY_LIST_STALE,
  CLEAR_INFORMATION_POLICY_LIST_STALE,
  MARK_ADMIN_SETTINGS_STALE,
  CLEAR_ADMIN_SETTINGS_STALE,
  MARK_CONFIG_SETTINGS_STALE,
  CLEAR_CONFIG_SETTINGS_STALE,
  MARK_GALLERY_LIST_STALE,
  CLEAR_GALLERY_LIST_STALE,
  MARK_OFFICIAL_CONTACT_LIST_STALE,
  CLEAR_OFFICIAL_CONTACT_LIST_STALE,
  MARK_ADMINISTRATION_LIST_STALE,
  CLEAR_ADMINISTRATION_LIST_STALE,
  MARK_PARISH_PRIEST_LIST_STALE,
  CLEAR_PARISH_PRIEST_LIST_STALE,
  MARK_LEADERSHIP_HISTORY_LIST_STALE,
  CLEAR_LEADERSHIP_HISTORY_LIST_STALE,
  MARK_HOUSE_LIST_STALE,
  CLEAR_HOUSE_LIST_STALE,
  MARK_HISTORY_LIST_STALE,
  CLEAR_HISTORY_LIST_STALE,
  MARK_HIERARCHY_LIST_STALE,
  CLEAR_HIERARCHY_LIST_STALE,
  MARK_CHURCH_LIST_STALE,
  CLEAR_CHURCH_LIST_STALE,
  MARK_ORGANIZATION_LIST_STALE,
  CLEAR_ORGANIZATION_LIST_STALE,
  MARK_MEMBERS_LIST_STALE,
  CLEAR_MEMBERS_LIST_STALE,
  MARK_CHAPEL_LIST_STALE,
  CLEAR_CHAPEL_LIST_STALE,
  MARK_NEWS_LIST_STALE,
  CLEAR_NEWS_LIST_STALE,
  MARK_FESTIVALS_LIST_STALE,
  CLEAR_FESTIVALS_LIST_STALE,
  MARK_ADVERTISEMENT_LIST_STALE,
  CLEAR_ADVERTISEMENT_LIST_STALE,
  MARK_OCCASION_LIST_STALE,
  CLEAR_OCCASION_LIST_STALE,
  MARK_LIVE_STREAMING_LIST_STALE,
  CLEAR_LIVE_STREAMING_LIST_STALE,
  MARK_INCOME_PDF_LINK_LIST_STALE,
  CLEAR_INCOME_PDF_LINK_LIST_STALE,
  MARK_EVENTS_LIST_STALE,
  CLEAR_EVENTS_LIST_STALE,
  MARK_QUOTES_LIST_STALE,
  CLEAR_QUOTES_LIST_STALE,
  MARK_POSITION_LIST_STALE,
  CLEAR_POSITION_LIST_STALE,
} from '../constants/PendingPublish';
import { PUBLISH_CONTENT_TYPES } from 'helpers/publishContentTypes';

export const enqueuePublishJob = (payload) => ({
  type: ENQUEUE_PUBLISH_JOB,
  payload,
});

export const updatePublishJobProgress = (payload) => ({
  type: UPDATE_PUBLISH_JOB_PROGRESS,
  payload,
});

export const removePublishJob = (id) => ({
  type: REMOVE_PUBLISH_JOB,
  payload: id,
});

export const markBannerListStale = () => ({ type: MARK_BANNER_LIST_STALE });
export const clearBannerListStale = () => ({ type: CLEAR_BANNER_LIST_STALE });
export const markTemplateListStale = () => ({ type: MARK_TEMPLATE_LIST_STALE });
export const clearTemplateListStale = () => ({ type: CLEAR_TEMPLATE_LIST_STALE });
export const markPagesListStale = () => ({ type: MARK_PAGES_LIST_STALE });
export const clearPagesListStale = () => ({ type: CLEAR_PAGES_LIST_STALE });
export const markCategoriesListStale = () => ({ type: MARK_CATEGORIES_LIST_STALE });
export const clearCategoriesListStale = () => ({ type: CLEAR_CATEGORIES_LIST_STALE });
export const markWidgetsListStale = () => ({ type: MARK_WIDGETS_LIST_STALE });
export const clearWidgetsListStale = () => ({ type: CLEAR_WIDGETS_LIST_STALE });
export const markSeoListStale = () => ({ type: MARK_SEO_LIST_STALE });
export const clearSeoListStale = () => ({ type: CLEAR_SEO_LIST_STALE });
export const markInformationPolicyListStale = () => ({
  type: MARK_INFORMATION_POLICY_LIST_STALE,
});
export const clearInformationPolicyListStale = () => ({
  type: CLEAR_INFORMATION_POLICY_LIST_STALE,
});
export const markAdminSettingsStale = () => ({ type: MARK_ADMIN_SETTINGS_STALE });
export const clearAdminSettingsStale = () => ({ type: CLEAR_ADMIN_SETTINGS_STALE });
export const markConfigSettingsStale = () => ({ type: MARK_CONFIG_SETTINGS_STALE });
export const clearConfigSettingsStale = () => ({ type: CLEAR_CONFIG_SETTINGS_STALE });

export const markGalleryListStale = () => ({ type: MARK_GALLERY_LIST_STALE });
export const clearGalleryListStale = () => ({ type: CLEAR_GALLERY_LIST_STALE });
export const markOfficialContactListStale = () => ({
  type: MARK_OFFICIAL_CONTACT_LIST_STALE,
});
export const clearOfficialContactListStale = () => ({
  type: CLEAR_OFFICIAL_CONTACT_LIST_STALE,
});
export const markAdministrationListStale = () => ({
  type: MARK_ADMINISTRATION_LIST_STALE,
});
export const clearAdministrationListStale = () => ({
  type: CLEAR_ADMINISTRATION_LIST_STALE,
});
export const markParishPriestListStale = () => ({
  type: MARK_PARISH_PRIEST_LIST_STALE,
});
export const clearParishPriestListStale = () => ({
  type: CLEAR_PARISH_PRIEST_LIST_STALE,
});
export const markLeadershipHistoryListStale = () => ({
  type: MARK_LEADERSHIP_HISTORY_LIST_STALE,
});
export const clearLeadershipHistoryListStale = () => ({
  type: CLEAR_LEADERSHIP_HISTORY_LIST_STALE,
});
export const markHouseListStale = () => ({ type: MARK_HOUSE_LIST_STALE });
export const clearHouseListStale = () => ({ type: CLEAR_HOUSE_LIST_STALE });
export const markHistoryListStale = () => ({ type: MARK_HISTORY_LIST_STALE });
export const clearHistoryListStale = () => ({ type: CLEAR_HISTORY_LIST_STALE });
export const markHierarchyListStale = () => ({ type: MARK_HIERARCHY_LIST_STALE });
export const clearHierarchyListStale = () => ({ type: CLEAR_HIERARCHY_LIST_STALE });
export const markChurchListStale = () => ({ type: MARK_CHURCH_LIST_STALE });
export const clearChurchListStale = () => ({ type: CLEAR_CHURCH_LIST_STALE });
export const markOrganizationListStale = () => ({
  type: MARK_ORGANIZATION_LIST_STALE,
});
export const clearOrganizationListStale = () => ({
  type: CLEAR_ORGANIZATION_LIST_STALE,
});
export const markMembersListStale = () => ({ type: MARK_MEMBERS_LIST_STALE });
export const clearMembersListStale = () => ({ type: CLEAR_MEMBERS_LIST_STALE });
export const markChapelListStale = () => ({ type: MARK_CHAPEL_LIST_STALE });
export const clearChapelListStale = () => ({ type: CLEAR_CHAPEL_LIST_STALE });
export const markNewsListStale = () => ({ type: MARK_NEWS_LIST_STALE });
export const clearNewsListStale = () => ({ type: CLEAR_NEWS_LIST_STALE });
export const markFestivalsListStale = () => ({ type: MARK_FESTIVALS_LIST_STALE });
export const clearFestivalsListStale = () => ({ type: CLEAR_FESTIVALS_LIST_STALE });
export const markAdvertisementListStale = () => ({
  type: MARK_ADVERTISEMENT_LIST_STALE,
});
export const clearAdvertisementListStale = () => ({
  type: CLEAR_ADVERTISEMENT_LIST_STALE,
});
export const markOccasionListStale = () => ({ type: MARK_OCCASION_LIST_STALE });
export const clearOccasionListStale = () => ({ type: CLEAR_OCCASION_LIST_STALE });
export const markLiveStreamingListStale = () => ({
  type: MARK_LIVE_STREAMING_LIST_STALE,
});
export const clearLiveStreamingListStale = () => ({
  type: CLEAR_LIVE_STREAMING_LIST_STALE,
});
export const markIncomePdfLinkListStale = () => ({
  type: MARK_INCOME_PDF_LINK_LIST_STALE,
});
export const clearIncomePdfLinkListStale = () => ({
  type: CLEAR_INCOME_PDF_LINK_LIST_STALE,
});
export const markEventsListStale = () => ({ type: MARK_EVENTS_LIST_STALE });
export const clearEventsListStale = () => ({ type: CLEAR_EVENTS_LIST_STALE });
export const markQuotesListStale = () => ({ type: MARK_QUOTES_LIST_STALE });
export const clearQuotesListStale = () => ({ type: CLEAR_QUOTES_LIST_STALE });
export const markPositionListStale = () => ({ type: MARK_POSITION_LIST_STALE });
export const clearPositionListStale = () => ({ type: CLEAR_POSITION_LIST_STALE });

export const markListStaleForContentType = (contentType) => {
  switch (contentType) {
    case PUBLISH_CONTENT_TYPES.BANNER:
      return markBannerListStale();
    case PUBLISH_CONTENT_TYPES.TEMPLATE:
      return markTemplateListStale();
    case PUBLISH_CONTENT_TYPES.PAGES:
      return markPagesListStale();
    case PUBLISH_CONTENT_TYPES.CATEGORIES:
      return markCategoriesListStale();
    case PUBLISH_CONTENT_TYPES.WIDGETS:
      return markWidgetsListStale();
    case PUBLISH_CONTENT_TYPES.SEO:
      return markSeoListStale();
    case PUBLISH_CONTENT_TYPES.INFORMATION_POLICY:
      return markInformationPolicyListStale();
    case PUBLISH_CONTENT_TYPES.ADMIN_SETTINGS:
      return markAdminSettingsStale();
    case PUBLISH_CONTENT_TYPES.CONFIG_SETTINGS:
      return markConfigSettingsStale();
    case PUBLISH_CONTENT_TYPES.GALLERY:
      return markGalleryListStale();
    case PUBLISH_CONTENT_TYPES.OFFICIAL_CONTACT:
      return markOfficialContactListStale();
    case PUBLISH_CONTENT_TYPES.ADMINISTRATION:
      return markAdministrationListStale();
    case PUBLISH_CONTENT_TYPES.PARISH_PRIEST:
      return markParishPriestListStale();
    case PUBLISH_CONTENT_TYPES.LEADERSHIP_HISTORY:
      return markLeadershipHistoryListStale();
    case PUBLISH_CONTENT_TYPES.HOUSE:
      return markHouseListStale();
    case PUBLISH_CONTENT_TYPES.HISTORY:
      return markHistoryListStale();
    case PUBLISH_CONTENT_TYPES.HIERARCHY:
      return markHierarchyListStale();
    case PUBLISH_CONTENT_TYPES.CHURCH:
      return markChurchListStale();
    case PUBLISH_CONTENT_TYPES.ORGANIZATION:
      return markOrganizationListStale();
    case PUBLISH_CONTENT_TYPES.MEMBERS:
      return markMembersListStale();
    case PUBLISH_CONTENT_TYPES.CHAPEL:
      return markChapelListStale();
    case PUBLISH_CONTENT_TYPES.NEWS:
      return markNewsListStale();
    case PUBLISH_CONTENT_TYPES.FESTIVALS:
      return markFestivalsListStale();
    case PUBLISH_CONTENT_TYPES.ADVERTISEMENT:
      return markAdvertisementListStale();
    case PUBLISH_CONTENT_TYPES.OCCASION:
      return markOccasionListStale();
    case PUBLISH_CONTENT_TYPES.LIVE_STREAMING:
      return markLiveStreamingListStale();
    case PUBLISH_CONTENT_TYPES.INCOME_PDF_LINK:
      return markIncomePdfLinkListStale();
    case PUBLISH_CONTENT_TYPES.EVENTS:
      return markEventsListStale();
    case PUBLISH_CONTENT_TYPES.QUOTES:
      return markQuotesListStale();
    case PUBLISH_CONTENT_TYPES.POSITION:
      return markPositionListStale();
    default:
      return { type: 'NOOP' };
  }
};
